import { startTransition, useCallback, useState } from "react";
import { SearchInput } from "components/common/SearchInput";
import type { SidebarSearchFieldProps } from "./types";

export const SidebarSearchField = ({
  placeholder,
  onSearchQueryChange,
}: SidebarSearchFieldProps) => {
  const [searchText, setSearchText] = useState("");

  // A keystroke re-renders only this field; the list follows in an interruptible transition
  const handleChange = useCallback(
    (text: string) => {
      setSearchText(text);
      startTransition(() => onSearchQueryChange(text.trim().toLowerCase()));
    },
    [onSearchQueryChange],
  );

  return (
    <div className="border-b border-gray-100 px-3 py-2">
      <SearchInput
        value={searchText}
        onChange={handleChange}
        placeholder={placeholder}
      />
    </div>
  );
};
